module.exports = __webpack_public_path__ + "static/img/yytx34.6c984a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx34.png
// module id = 812
// module chunks = 0